import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { setDriverIndexAction, setUIBackwardsAction, setUIForwardAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import { AppState } from '../../../reducers'
import FooterMobile from '../../FooterMobile'
import DriversDocumentMobile from '../DriversDocumentMobile'
import DriversInformationMobile, { CustomDriversInformationMobileRefProps } from '../DriversInformationMobile'
import './driversInformationAndDocument.less'

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  setDriverIndex: setDriverIndexAction,
}
type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  isDocumentRequires: state.reservation.isDocumentRequires,
  reservation: state.reservation.reservation,
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = StateProps & DispatchProps

const DriversInformationAndDocument: React.FC<Props> = ({ isDocumentRequires, reservation, setDriverIndex, setUIForward, setUIBackwards }) => {
  const { t } = useTranslation()
  const [showDocument, setShowDocument] = useState(false)
  const [isDocumentError, setIsDocumentError] = useState(false)

  const refDriversInformation = useRef<CustomDriversInformationMobileRefProps>(null)

  const onClick = () => {
    const isValidInformation = refDriversInformation.current && refDriversInformation.current.processValidationAllData()
    if (!isValidInformation || isDocumentError) {
      return
    }
    if (reservation && reservation.drivers.length > 1) {
      setDriverIndex(1)
      setUIForward(UI.DRIVER2_INFORMATION_AND_DOCUMENT_MOBILE)
    } else {
      setUIForward(UI.SUMMARY)
    }
  }

  const onDriverInformationSubmit = () => {
    if (showDocument) {
      // set focus to document
    } else {
      onClick()
    }
  }

  useEffect(() => {
    setShowDocument(isDocumentRequires)
  }, [isDocumentRequires])

  return (
    <div className="driver-information-document-mobile">
      <div className="driver-information-document-mobile-wrapper">
        <div className="driver-information-container">
          <DriversInformationMobile ref={refDriversInformation} onDriverInformationSubmit={onDriverInformationSubmit} />
        </div>
        {showDocument && (
          <div className="driver-document-container">
            <DriversDocumentMobile setDocumentInputError={setIsDocumentError} />
          </div>
        )}
        <button className="main-button-mobile" onClick={onClick} disabled={!!isDocumentError}>
          {t('next')}
        </button>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount back={() => setUIBackwards(UI.FROM_TO)} />
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(DriversInformationAndDocument)
